/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import type {Calendar} from './index';

export function template(this: Calendar) {
  return <div sel='.calendar' />;
}
